module.exports = __webpack_public_path__ + "static/media/user-small.a1dcf194.png";